export default "<div [chart]=\"oxygenInstant\"></div>"